import React from 'react';
import ResetPasswordPageView from 'views/ResetPasswordPage';
import Head from 'next/head';
import buildPageAnalytics from 'helpers/buildPageAnalytics';
import { RESET_PASSWORD_PAGE_NAME } from 'constants/pageNames';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

const ResetPasswordPage = () => (
  <>
    <Head>
      <title>Reset Password | The Bash</title>
    </Head>
    <ResetPasswordPageView />
  </>
);

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, async (ctx) => {
      const pageAnalytics = buildPageAnalytics(RESET_PASSWORD_PAGE_NAME);

      return {
        ...pageAnalytics,
      };
    })
);

export default ResetPasswordPage;
